import { NewPeriod } from '@app/models/period';
import api from '@services/api';

import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all resource period related CRUD calls
 */
export const periodApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    Periods: builder.query<PaginationResponse<NewPeriod>, void>({
      query: () => ({
        url: encodeURI('/school/period/search?page=0&size=10&sortKey=date&sortDirection=DESC'),
        method: 'GET',
      }),
      providesTags: ['Periods'],
    }),
  }),
});

export const { usePeriodsQuery } = periodApi;
